import { QCONTENT_COLOR_STATUS } from '@exam-management/components';
import type { SearchQuestionsQuery } from '@exam-management/graphql';
import { Link } from '@exam-management/router';
import { type ColorPalette, Link as BaseLink, Text, LaunchRoundedIcon } from '@shared/components';

import { QuestionInLocation } from '../question-in-location';

type SingleQuestion = SearchQuestionsQuery['qctSearchQuestions']['questions'][number];

export interface SingleQuestionInLocationProps {
  question: SingleQuestion;
  highlight?: boolean;
}

export default function SingleQuestionInLocation(props: Readonly<SingleQuestionInLocationProps>) {
  const { question, highlight: isHighlight = false } = props;

  const statusColor = QCONTENT_COLOR_STATUS[question.status];

  return (
    <BaseLink
      component={Link}
      to='/qbank-structures/:structureId/qcontents/single/:contentId'
      params={{
        structureId: question.refQBankStructureId,
        contentId: question.id,
      }}
      target='_blank'
      rel='noreferrer'
      sx={{ lineHeight: 0, textDecoration: 'none', color: (theme) => theme.palette.text.primary }}
    >
      <QuestionInLocation
        statusColor={statusColor as ColorPalette}
        content={<Text variant='body2'>{question.refCode}</Text>}
        highlight={isHighlight}
        endAdornment={
          <LaunchRoundedIcon
            sx={(theme) => ({
              fontSize: '24px',
              color: theme.palette.grey[500],
              ml: theme.spacing(1),
            })}
          />
        }
      />
    </BaseLink>
  );
}
